<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nUUDVL/tc-custom/9781429953498.jpg?1726444326102" alt="This image is the cover for the book Wake Up Dead, Cape Town Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wake Up Dead, Cape Town Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An amphetamine-fueled thriller about a bombshell American widow on the run in Cape Town's violent badlands—from a writer being compared to George Pelecanos and Richard Price</b><br/><br/>A split-second decision with no second chance: get it wrong and you wake up dead.<br/><br/>On a blowtorch-hot night in Cape Town, American ex-model Roxy Palmer and her gunrunner husband, Joe, are carjacked, leaving Joe lying in a pool of blood. As the carjackers make their getaway, Roxy makes a fateful choice that changes her life forever. <br/><br/>Disco and Godwynn, the ghetto gangbangers who sped away in Joe's convertible, will stop at nothing to track her down. Billy Afrika, a mixed-race ex-cop turned mercenary, won't let her out of his sight because Joe owed him a chunk of money. And remorselessly hunting them all is Piper, a love-crazed psychopath determined to renew his vows with his jailhouse "wife," Disco.<br/><br/>As these desperate lives collide and old debts are settled in blood, Roxy is caught in a wave of escalating violence in the beautiful and brutal African seaport. With savage plotting and breakneck suspense that ends in a shattering cataclysm of violence, <i>Wake Up Dead</i> confirms Roger Smith as one of the world's best new thriller writers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roger Smith
      </h2>
      
      <p class="authorDescription body article"><B>Roger Smith</B>, an accomplished screenwriter, director, and producer, was born in Johannesburg, South Africa, and now lives in Cape Town. He is the author of the thrillers <I>Mixed Blood</I> and <I>Wake Up Dead</I> and is writing a third novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f3cbe984